import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import Home from '../components/Home';
import Guidebooks from './guidebooks/Guidebooks';
import GuidebookChapter from './guidebooks/GuidebookChapter';
import SingleResource from './resources/SingleResource';

const router = createBrowserRouter([
  {
    path: '*',
    element: <ErrorPage />,
  },
  {
    path: '/library',
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/library/guidebooks',
    element: <Guidebooks />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/library/guidebooks/:guidebookSlug',
    element: <GuidebookChapter />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/library/guidebooks/:guidebookSlug/:chapterSlug',
    element: <GuidebookChapter />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/library/resources/:resourceSlug',
    element: <SingleResource />,
    errorElement: <ErrorPage />,
  },
]);

let App = () => {
  return <RouterProvider router={router} />;
};

export default App;
